import { usePageMeta } from '@/hooks/usePageMeta';
import { useLocation } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import UpcomingPerformance from './components/UpcomingPerformance';
import AboutPreview from './components/AboutPreview';

export default function Home() {
  const location = useLocation();

  usePageMeta(
    'Keaton Brown | Baritone — Opera, Concert, Musical Theatre | Houston, TX',
    'Keaton Brown is a versatile baritone performing opera, concert work, and musical theatre. Recent and upcoming engagements include Opera San Jose, Nashville Opera, Opera North (USA), HOPERA, and Houston Grand Opera. Based in Houston, Texas.'
  );

  return (
    <main>
      <HeroSection />
      <UpcomingPerformance />
      <AboutPreview />
    </main>
  );
}